/**
 * created by lei lei
 *桌面任务清单
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Card from '../../../components/card/Card'
import {DatePicker, Empty, Pagination, Radio, Tabs} from 'antd';
import moment from 'moment';
import CustomTable, {TitleIcon} from "../../../components/customTable/CustomTable";
import {Scrollbars} from "react-custom-scrollbars";
import VerticalCenter from "../../../components/verticalCenter/VerticalCenter"
import *as utils from '../../../../utils';
import {permissionCheck} from "../../../../utils";
import request from "../../../../base/request";
import {applicationName} from "../../../../utils";


const {MonthPicker, RangePicker} = DatePicker;
const dateFormat = 'YYYY-MM-DD';
const {TabPane} = Tabs;

export default class TaskList extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            timeStatus: '1',
            startDate: moment().add(-6, 'days'),
            endDate: moment(),
            start: 1,
            size: 10,
            dataSource: [],
            count: 0,
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.getList()
    }

    getList() {
        let params = {
            start: this.state.start,
            size: this.state.size,
            startDate: utils.formatDate(this.state.startDate),//.format(' YYYY-MM-DD'),
            endDate: utils.formatDate(this.state.endDate),//.format(' YYYY-MM-DD'),
        };
        getTaskList(params, res => {
            if (res) {
                this.setState({
                    dataSource: res.data,
                    count: res.count,
                })
            }
        })
    }

    render() {
        let isAuth = permissionCheck("pms:interviewList");//是否展示任务清单模块
        if(!isAuth){
            return <div></div>
        }
        let titleKeyList =
            [{
                key: 'interviewDate',
                titleName: '时间',
                width: 100,
                align: 'center',
                ellipsis: true,
                render: (text, record, index) => {
                    return <span style={{fontSize: 15, color: '#8792b3'}}>{record.interviewDate}</span>
                }
            },
                {
                    key: 'title',
                    titleName: '标题',
                    width: 300,
                    align: 'left', ellipsis: true,
                    render: (text, record, index) => {
                        return <span style={{fontSize: 15, color: '#2a3a6b'}} title={record.title}>{record.title}</span>
                    }
                },
                {
                    key: 'interviewJointerAccounts',
                    titleName: '记者',
                    width: '20%', ellipsis: true,
                    render: (text, record, index) => {
                        let list = record.interviewJointerAccounts.split('、');
                        return (
                            <div>
                                {
                                    list.map((item, index) => {
                                        if (!item) {
                                            return
                                        }
                                        return <div key={index} style={{
                                            fontSize: 15,
                                            color: '#727ea2',
                                            background: '#f4f6fc',
                                            borderRadius: '13px',
                                            float: 'left',
                                            padding: 5,
                                            marginLeft: 5,
                                            marginTop: 5
                                        }}
                                                    title={item}>{item}</div>
                                    })
                                }
                            </div>
                        )
                    }
                }, {
                key: 'status',
                titleName: '状态',
                width: '20%', ellipsis: true,
                render: (text, record, index) => {
                    let statusName;
                    let statusColor;
                    switch (record.status) {
                        case 1:
                            statusName = '未领取';
                            statusColor = '#ffa82b';
                            break;
                        case 2:
                            statusName = '进行中';
                            statusColor = '#5a63e6';
                            break;
                        case 3:
                            statusName = '已提交';
                            statusColor = '#35ce84';
                            break;
                        case 4:
                            statusName = '已完成';
                            statusColor = '#979caa';
                            break;
                        case 5:
                            statusName = '已超期';
                            statusColor = '#ffa82b';
                            break;
                    }
                    return (<span style={{color: statusColor, fontSize: 14}}>·&nbsp;{statusName}</span>)
                }
            }, {
                key: 'mediaNames',
                titleName: '来源',
                width: '20%', ellipsis: true,
                render: (text, record, index) => {
                    return <span style={{fontSize: 15, color: '#8792b3'}}
                                 title={record.mediaNames}>{record.mediaNames}</span>
                }
            },];
        return (
            <div style={{marginTop: 20}}>
                <Card title={'任务清单'}>
                    <div style={{marginTop: 10, textAlign: 'right'}}>
                        {/* <Radio.Group  value={this.state.timeStatus} onChange={this.handleSizeChange}>
                            <Radio.Button value="1">近一周</Radio.Button>
                            <Radio.Button value="2">未来一周</Radio.Button>
                            <Radio.Button value="3">未来一月</Radio.Button>
                        </Radio.Group>*/}
                        <div style={{display: 'flex'}}>
                            <div style={{marginLeft: 20}}>
                                <Tabs activeKey={this.state.timeStatus} tabBarGutter={1}
                                      onChange={this.handleSizeChange}>
                                    <TabPane tab="近一周" key="1">
                                    </TabPane>
                                    <TabPane tab="未来一周" key="2">
                                    </TabPane>
                                    <TabPane tab="未来一月" key="3">
                                    </TabPane>
                                </Tabs>
                            </div>
                            <div style={{width: 900}}></div>
                            <RangePicker style={{marginLeft: 10, marginRight: 20, textAlign: "center", marginTop: 10}}
                                         value={[this.state.startDate, this.state.endDate]}
                                         format={dateFormat}
                                         onChange={(date, dateString) => {
                                             this.state.startDate = date[0];
                                             this.state.endDate = date[1];
                                             this.getList();
                                         }}
                            />
                        </div>

                        {this.state.dataSource && (this.state.dataSource.length > 0) ? <div>
                            <div style={{height: 370}}>
                                <Scrollbars>
                                    <div style={{height: 370}}>
                                        <CustomTable
                                            dataSource={this.state.dataSource}
                                            titleKeyList={titleKeyList}
                                            showHeader={false}
                                            //下面属性参考antd table  属性去使用对外暴露，会全部引用用antd 的属性。
                                            pagination={false}
                                            onRow={(record, index) => {
                                                return {
                                                    onClick: event => {
                                                        console.log('onclickItem', record, index)
                                                    }, // 点击行
                                                    onDoubleClick: event => {
                                                    },
                                                    onContextMenu: event => {
                                                    },
                                                    onMouseEnter: event => {
                                                    }, // 鼠标移入行
                                                    onMouseLeave: event => {
                                                    },
                                                };
                                            }}
                                            locale={{emptyText: '暂无数据'}}
                                        />
                                    </div>
                                </Scrollbars>
                            </div>
                            <div style={{marginRight: 10}}>
                                <Pagination
                                    showQuickJumper
                                    // defaultCurrent={2}
                                    current={this.state.start}
                                    pageSize={this.state.size}
                                    total={this.state.count}
                                    showTotal={total => `共 ${total} 条`}
                                    showSizeChanger
                                    onChange={(page, pageSize) => this.onChange(page, pageSize)}
                                    onShowSizeChange={(page, pageSize) => {
                                        this.onChange(page, pageSize)
                                    }}
                                />
                            </div>
                        </div> : <div style={{height: 402}}><VerticalCenter
                            style={{height: '100%'}}><Empty/></VerticalCenter></div>}

                    </div>
                </Card>
            </div>
        )
    }

    handleSizeChange = e => {
        let key = e;
        if (key === "1") {
            this.state.startDate = moment().add(-6, 'days');
            this.state.endDate = moment();
        } else if (key === "2") {
            this.state.startDate = moment();
            this.state.endDate = moment().add(6, 'days');
        } else if (key === "3") {
            this.state.startDate = moment();
            this.state.endDate = moment().add(30, 'days');
        }
        this.state.timeStatus = key;
        this.state.start = 1;
        this.state.size = 10;
        this.getList();
    };

    onChange(page, pageSize) {
        this.state.start = page;
        this.state.size = pageSize;
        this.getList()
    }

}
const host = "/cm-sites-" + applicationName() + '/';
//获取任务列表
export const getTaskList = (body, callBack) => {
    request({url:host + "interview/desktopTaskList", body, callBack});
};